<div class="rk-ui-notification err" *ngIf="erroralert"  style="z-index: 10000;">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
<div class="rk-ui-notification" *ngIf="successalert"  style="z-index: 10000;">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>

<div class="container-fluid mt-4">
	<div class="row">
		<div class="col-lg-12 col-md-12 col-sm-12" style="
    border: 1px solid #efefef;">
			<div class="row"> 
				<div class="header col-12" style="padding-left: 36px">Key Decision Maker</div>
			</div>	
			
			<!--questionnaireForm Started-->
			<form [formGroup]="questionnaireForm">
				<div class="col-sm-12 pl-4">
					<div class="row mt-4">
						<div class="col-sm-6">
							<label class="customLabel font-weight-bold mb-0">Name<span class="text-danger">*</span></label>
            	<input type="text" class="form-control nameInput" formControlName="name" readonly/>
						</div>

						<div class="col-sm-6">
							<label class="customLabel font-weight-bold mb-0">Email<span class="text-danger">*</span></label>
            	<input type="text" class="form-control nameInput" formControlName="email" readonly/>

            	<div *ngIf="questionnaireForm.controls['email'].errors && !questionnaireForm.controls['email'].pristine" class="text-danger">

                <div [hidden]="questionnaireForm.controls['email'].valid">Enter valid email.</div>
              </div>
						</div>

						<div class="col-sm-6 mt-4" *ngIf = "role=='community_manager'">
							<label class="customLabel font-weight-bold mb-0">Phone<span class="text-danger">*</span></label>
            	<input type="tel" pattern="[0-9]{10}" class="form-control nameInput" formControlName="phone" readonly/>

            	<div *ngIf="questionnaireForm.controls['phone'].errors && !questionnaireForm.controls['phone'].pristine" class="text-danger">

                <div [hidden]="questionnaireForm.controls['phone'].valid">Enter valid phone number.</div>
              </div>
						</div>

						<div class="col-sm-6 mt-4">
							<label class="customLabel font-weight-bold mb-0">Date of Birth<span class="text-danger">*</span></label>
            	<!-- <input type="date" class="form-control nameInput addCursor" formControlName="dob"> -->

            	<input [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" placeholder="Enter Date" formControlName="dob" class="form-control" style="width: 170px !important;"/>
            	<owl-date-time #dt1 [pickerType]="'calendar'" [startView]="'month'"></owl-date-time> 
						</div>

						<div class="col-sm-6 mt-4">
							<label class="customLabel font-weight-bold mb-0">Address Line 1<span class="text-danger">*</span></label>
            	<textarea type="text" class="form-control nameInput" formControlName="address_line1" rows="3" cols="50"></textarea>
						</div>

						<div class="col-sm-6 mt-4">
							<label class="customLabel font-weight-bold mb-0">Address Line 2</label>
            	<textarea type="text" class="form-control nameInput" formControlName="address_line2" rows="3" cols="50"></textarea>
						</div>

						<div class="col-sm-6 mt-4">
							<label class="customLabel font-weight-bold mb-0">City<span class="text-danger">*</span></label>
            	<input type="text" class="form-control nameInput" formControlName="city"/>
						</div>

						<div class="col-sm-6 mt-4">
							<label class="customLabel font-weight-bold mb-0">State<span class="text-danger">*</span></label>
            	<input type="text" class="form-control nameInput" formControlName="state"/>
						</div>

						<div class="col-sm-6 mt-4">
							<label class="customLabel font-weight-bold mb-0">Pincode<span class="text-danger">*</span></label>
            	<input type="number" class="form-control nameInput" formControlName="pincode" style="width: 149px !important;"/>
						</div>

						<div class="col-sm-12 mt-4">
							<label class="customLabel font-weight-bold mb-0">Gender<span class="text-danger">*</span></label>
							<div class="ml-1">
		            <label class="form-check-label addCursor text-capitalize lableSize labelColor mb-2 mr-4" *ngFor="let at of gender_value">
		              <input class="form-check-input addCursor customeRadio" type="radio" value="{{at}}" formControlName="gender"/>
		              {{at | replaceChar}}
		            </label>
		          </div>	
						</div>

						<div class="col-sm-12 mt-4">
							<label class="customLabel font-weight-bold mb-0">Education Background<span class="text-danger">*</span></label>
							<div class="ml-1">
		            <label class="form-check-label addCursor text-capitalize lableSize labelColor mb-2 mr-4" *ngFor="let at of education_background_value">
		              <input class="form-check-input addCursor customeRadio" type="radio" value="{{at}}" formControlName="education_background"/>
		              {{at | replaceChar}}
		            </label>
		          </div>	
						</div>

						<div class="col-sm-12 mt-4">
							<label class="customLabel font-weight-bold mb-0">Professional Background<span class="text-danger">*</span></label>
							<div class="ml-1">
		            <label class="form-check-label addCursor text-capitalize lableSize labelColor mb-2 mr-4" *ngFor="let at of professional_background_value">
		              <input class="form-check-input addCursor customeRadio" type="radio" value="{{at}}" formControlName="professional_background"/>
		              {{at | replaceChar}}
		            </label>
		          </div>	
						</div>

						<div class="col-sm-12 mt-4">
							<label class="customLabel font-weight-bold mb-0">Sector Employed<span class="text-danger">*</span></label>
							<div class="ml-1">
		            <label class="form-check-label addCursor text-capitalize lableSize labelColor mb-2 mr-5" *ngFor="let at of sector_employed_value">
		              <input class="form-check-input addCursor customeRadio" type="radio" value="{{at}}" formControlName="sector_employed"/>
		              {{at | replaceChar}}
		            </label>
		          </div>	
						</div>

						<div class="col-sm-12 mt-4">
							<label class="customLabel font-weight-bold mb-0">Income Per Annum<span class="text-danger">*</span></label>
							<div class="ml-1">
		            <label class="form-check-label addCursor text-capitalize lableSize labelColor mb-2 mr-4" *ngFor="let at of income_per_value">
		              <input class="form-check-input addCursor customeRadio" type="radio" value="{{at}}" formControlName="income_per">
		              {{at | replaceChar}}
		            </label>
		          </div>	
						</div>

						<div class="col-sm-12 mt-4">
							<label class="customLabel font-weight-bold mb-0">Family Status<span class="text-danger">*</span></label>
							<div class="ml-1">
		            <label class="form-check-label addCursor text-capitalize lableSize labelColor mb-2 mr-4">
		              <input class="form-check-input addCursor customeRadio" type="radio" value="nuclear_family" formControlName="family_status" (change) = "familyStatusSelect('nuclear')"/>
		              nuclear family
		            </label>

		            <label class="form-check-label addCursor text-capitalize lableSize labelColor mb-2 mr-4">
		              <input class="form-check-input addCursor customeRadio" type="radio" value="joint_family" formControlName="family_status" (change) = "familyStatusSelect('joint')"/>
		              joint family
		            </label>
		          </div>	
						</div>
						
						<div class="col-sm-12 mt-4" id="material" style="display: none;">
							<label class="customLabel addCursor font-weight-bold mb-0">Marital Status<span class="text-danger">*</span></label>
							<div class="ml-1">
		            <label class="form-check-label text-capitalize lableSize labelColor mb-2 mr-4" *ngFor="let at of matrial_status_value">
		              <input class="form-check-input addCursor customeRadio" type="radio" value="{{at}}" formControlName="matrial_status" (change) = "familyMemberCount();"/>
		              {{at | replaceChar}}
		            </label>
		          </div>	
						</div>

						<div class="col-sm-12 mt-4" id="joint" style="display: none;">
							<label class="customLabel font-weight-bold mb-0">Joint Family Status<span class="text-danger">*</span></label>
							<div class="ml-1">
		            <label class="form-check-label addCursor text-capitalize lableSize labelColor mb-2 mr-4" *ngFor="let at of joint_family_status_value">
		              <input class="form-check-input addCursor customeRadio" type="radio" value="{{at}}" formControlName="joint_family_status" (change) = "familyMemberCount();"/>
		              {{at | replaceChar}}
		            </label>
		          </div>	
						</div>
						
						<div class="col-sm-12 mt-4" id="familyMember" style="display: none;">
							<label class="customLabel font-weight-bold mb-0">Number of Family Menbers<span class="text-danger">*</span></label>
							<div class="ml-1">
		            <label class="form-check-label addCursor text-capitalize lableSize labelColor mb-2 mr-4" *ngFor="let at of family_member_value">
		              <input class="form-check-input addCursor customeRadio" type="radio" value="{{at}}" formControlName="family_member" (change) = "decisionMaker();"/>
		              {{at | replaceChar}}
		            </label>
		          </div>	
						</div>

						<div class="col-sm-12 mt-4" id="decisionMaker" style="display: none;">
							<label class="customLabel font-weight-bold mb-0">Co-Decision Maker<span class="text-danger">*</span></label>
							<div class="ml-1">
		            <label class="form-check-label addCursor text-capitalize lableSize labelColor mb-2 mr-4">
		              <input class="form-check-input addCursor customeRadio" type="radio" value="Yes" formControlName="decision_maker" (change) = "showdecisionMaker('yes');"/>
		              Yes
		            </label>

		            <label class="form-check-label addCursor text-capitalize lableSize labelColor mb-2 mr-4">
		              <input class="form-check-input addCursor customeRadio" type="radio" value="No" formControlName="decision_maker" (change) = "showdecisionMaker('no');"/>
		              No
		            </label>
		          </div>	
						</div>
						
						<div class="col-sm-12 mt-4" id="decisionMakerDetails" style="display: none;">
							<div class="row">
								<div class="col-sm-6">
									<label class="customLabel font-weight-bold mb-0">Name</label>
		            	<input type="text" class="form-control nameInput" formControlName="decision_name"/>
								</div>

								<div class="col-sm-6">
									<label class="customLabel font-weight-bold mb-0">Email</label>
		            	<input type="email" class="form-control nameInput" formControlName="decision_email"/>   	
            			<div *ngIf="questionnaireForm.controls['decision_email'].errors && !questionnaireForm.controls['decision_email'].pristine" class="text-danger">

               		 <div [hidden]="questionnaireForm.controls['decision_email'].valid">Enter valid email.</div>
              		</div>
								</div>

								<div class="col-sm-6 mt-4">
									<label class="customLabel font-weight-bold mb-0">Phone</label>
		            	<input type="tel" pattern="[0-9]{10}" class="form-control nameInput" formControlName="decision_phone"/>
								
								<div *ngIf="questionnaireForm.controls['decision_phone'].errors && !questionnaireForm.controls['decision_phone'].pristine" class="text-danger">

                	<div [hidden]="questionnaireForm.controls['decision_phone'].valid">Enter valid phone number.</div>
             		</div>
								</div>

								<div class="col-sm-6 mt-4">
									<label class="customLabel font-weight-bold mb-0">Date of Birth</label>
		            	<input [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2" placeholder="Enter Date" formControlName="decision_dob" class="form-control" style="width: 170px !important;"/>
            			<owl-date-time #dt2 [pickerType]="'calendar'" [startView]="'month'"></owl-date-time>
								</div>

								<div class="col-sm-12 mt-4">
									<label class="customLabel font-weight-bold mb-0">Relationship w/Key Decision Maker</label>
									<div class="ml-1">
				            <label class="form-check-label addCursor text-capitalize lableSize labelColor mb-2 mr-4" *ngFor="let at of relationship_decision_maker_value">
				              <input class="form-check-input addCursor customeRadio" type="radio" value="{{at}}" formControlName="relationship_decision_maker"/>
				              {{at | replaceChar}}
				            </label>
				          </div>	
								</div>
								

								<div class="col-sm-12 mt-4">
									<label class="customLabel font-weight-bold mb-0">Education Background</label>
									<div class="ml-1">
				            <label class="form-check-label addCursor text-capitalize lableSize labelColor mb-2 mr-4" *ngFor="let at of education_background_value">
				              <input class="form-check-input addCursor customeRadio" type="radio" value="{{at}}" formControlName="decision_education_background"/>
				              {{at | replaceChar}}
				            </label>
				          </div>	
								</div>

								<div class="col-sm-12 mt-4">
									<label class="customLabel font-weight-bold mb-0">Professional Background</label>
									<div class="ml-1">
				            <label class="form-check-label addCursor text-capitalize lableSize labelColor mb-2 mr-4" *ngFor="let at of professional_background_value">
				              <input class="form-check-input addCursor customeRadio" type="radio" value="{{at}}" formControlName="decision_professional_background"/>
				              {{at | replaceChar}}
				            </label>
				          </div>	
								</div>

								<div class="col-sm-12 mt-4">
									<label class="customLabel font-weight-bold mb-0">Sector Employed</label>
									<div class="ml-4">
				            <label class="form-check-labeladdCursor text-capitalize lableSize labelColor mb-2 mr-5" *ngFor="let at of sector_employed_value">
				              <input class="form-check-input addCursor customeRadio" type="radio" value="{{at}}" formControlName="decision_sector_employed"/>
				              {{at | replaceChar}}
				            </label>
				          </div>	
								</div>

								<div class="col-sm-12 mt-4">
									<label class="customLabel font-weight-bold mb-0">Income Per Annum</label>
									<div class="ml-1">
				            <label class="form-check-label addCursor text-capitalize lableSize labelColor mb-2 mr-4" *ngFor="let at of income_per_value">
				              <input class="form-check-input addCursor customeRadio" type="radio" value="{{at}}" formControlName="decision_income_per"/>
				              {{at | replaceChar}}
				            </label>
				          </div>	
								</div>
							</div>
						</div>
						
						<div class="col-sm-12 mt-4" id="movingDate" style="display: none;">
							<label class="customLabel font-weight-bold mb-0">When do you want to move in to your new house?</label><span class="text-danger">*</span>
            	<input [owlDateTime]="dt3" [owlDateTimeTrigger]="dt3" placeholder="Enter Date" formControlName="moving_date" class="form-control" style="width: 170px !important;"/>
            	<owl-date-time #dt3 [pickerType]="'calendar'" [startView]="'month'"></owl-date-time>
						</div>
						
						<div class="col-sm-12 mt-4" id="housePurpose" style="display: none;">
							<label class="customLabel font-weight-bold mb-0">Do you widh to use the house for yourself or renting purpose?</label><span class="text-danger">*</span>
							<div class="ml-1">
		            <label class="form-check-label addCursor text-capitalize lableSize labelColor mb-2 mr-4" *ngFor="let at of house_purpose_value">
		              <input class="form-check-input addCursor customeRadio" type="radio" value="{{at}}" formControlName="house_purpose"/>
		              {{at | replaceChar}}
		            </label>
		          </div>	
						</div>

						<div class="ml-auto mt-4 mb-4">
							<button class="btn btn-pink addCursor" type="submit" [disabled] = "!questionnaireForm.valid" (click)="editQuestionnaire(questionnaireForm.value);" *ngIf="questionnaireFormDetails">Update</button>

							<button class="btn btn-pink addCursor" type="submit" [disabled] = "!questionnaireForm.valid" (click)="submitQuestionnaire(questionnaireForm.value);" *ngIf="questionnaireFormDetails==null">Submit</button>
						</div>
					</div>
				</div>
			</form>		
		</div>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/designerquestionnaire/designerquestionnaire.component.html